import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);

    if (loading) return <div>Loading...</div>;

    // Allow BOTH 'admin' and 'superadmin'
    if (user && (user.role === 'admin' || user.role === 'superadmin')) {
        return children;
    }

    return <Navigate to="/dashboard" />;
};

export default AdminRoute;